export default class Modal {
  constructor(cssClass = 'modal', bodyClass = 'modal-mode') {
    this.modal = null;
    this.modalContent = null;
    this.modalClose = null;
    this.cssClass = cssClass;
    this.bodyClass = bodyClass;

    this.init();
    this.addEvents();
  }

  init = () => {
    this.modal = document.createElement('div');
    this.modal.classList.add(this.cssClass);

    this.modalContent = document.createElement('div');
    this.modalContent.classList.add(`${this.cssClass}-content`);
    this.modal.appendChild(this.modalContent);

    this.modalClose = document.createElement('span');
    this.modalClose.classList.add(`${this.cssClass}-close`);
    this.modalContent.appendChild(this.modalClose);

    document.body.appendChild(this.modal);
  }

  addEvents = () => {
    this.modalClose.addEventListener('click', () => this.hide());
    this.modal.addEventListener('click', this.handleClick);
    document.addEventListener('keydown', this.handleKeyEscDown);
  }

  /** @private */
  handleClick = (e) => {
    if (e.target === this.modal) {
      this.hide();
    }
  }

  /** @private */
  handleKeyEscDown = (e) => {
    if (e.key === "Escape" || e.key === "Esc" || e.keyCode === 27) {
      this.hide();
    }
  };

  show = () => {
    this.modal.classList.add('show');
    document.body.classList.add(this.bodyClass);
  }

  // Скрыть модальное окно
  hide = () => {
    this.modal.classList.remove('show');
    document.body.classList.remove(this.bodyClass);
  }

  setContent = (content) => {
    this.modalContent.innerHTML = content;
    this.modalContent.appendChild(this.modalClose);
  }
}